(function() {
  function initWaiverGate(configEl) {
    if (!configEl) return;
    var config = {};
    try {
      config = JSON.parse(configEl.textContent || '{}');
    } catch (err) {
      config = {};
    }
    var sectionId = config.sectionId || '';
    var root = configEl.closest ? configEl.closest('.waiver-gate-root') : null;
    if (!root && sectionId) {
      root = document.getElementById('waiver-gate-root-' + sectionId);
    }
    if (!root) return;
    if (root.dataset && root.dataset.waiverInit === 'true') return;
    if (root.dataset) root.dataset.waiverInit = 'true';

    var settings = config.settings || {};
    var productWaiver = config.productWaiver || '';
    var cartToken = config.cartToken || '';
    var productId = config.productId || '';
    var variantWaiverMap = config.variantWaiverMap || {};
    var modalId = 'waiver-gate-modal-' + sectionId;
function normalizeUrl(url) {
  if (!url) return '';
  var value = String(url).trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  return 'https://' + value;
}

function log(label, data) {
  if (!settings.debug || !window.console) return;
  if (data !== undefined) {
    console.log('[Waiver Gate]', sectionId, label, data);
  } else {
    console.log('[Waiver Gate]', sectionId, label);
  }
}

function isParticipantInfoComplete() {
  return !!(state.participantName && state.participantEmail && state.participantPhone);
}

function requiresParticipantInfo() {
  return settings.allowMultipleSessions && !isParticipantInfoComplete();
}

function findContainer() {
  var sectionEl = root.closest('section');
  if (sectionEl && sectionEl.querySelector('form[action^="/cart/add"]')) {
    return sectionEl;
  }
  var node = root.parentElement;
  while (node) {
    if (node.querySelector && node.querySelector('form[action^="/cart/add"]')) {
      return node;
    }
    node = node.parentElement;
  }
  return null;
}

var container = findContainer();
log('container-detected', { found: !!container });

var cachedForm = null;
function getForm() {
  if (!container) return null;
  if (cachedForm && document.contains(cachedForm)) return cachedForm;
  var primary = container.querySelector('form[action^="/cart/add"][data-type="add-to-cart-form"], form[action^="/cart/add"][is="product-form"]');
  if (primary) {
    cachedForm = primary;
    return primary;
  }
  var forms = container.querySelectorAll('form[action^="/cart/add"]');
  for (var i = 0; i < forms.length; i++) {
    if (forms[i].querySelector('button[name="add"], button[type="submit"], input[type="submit"]')) {
      cachedForm = forms[i];
      return forms[i];
    }
  }
  cachedForm = forms.length ? forms[0] : null;
  return cachedForm;
}

var cachedBuyNow = null;
function getBuyNowButton() {
  if (!container) return null;
  if (cachedBuyNow && document.contains(cachedBuyNow)) return cachedBuyNow;
  cachedBuyNow = container.querySelector('button[name="checkout"], button[data-testid="Checkout-button"], .shopify-payment-button__button');
  return cachedBuyNow;
}

function getSelectedVariantId() {
  var form = getForm();
  var idInput = form ? form.querySelector('input[name="id"]') : null;
  if (idInput && idInput.value) {
    return idInput.value;
  }
  var script = container ? container.querySelector('script[type="application/json"][data-selected-variant]') : null;
  if (script) {
    try {
      var data = JSON.parse(script.textContent);
      if (data && data.id) {
        return String(data.id);
      }
    } catch (err) {
      return null;
    }
  }
  return null;
}

function getActiveInfo() {
  var variantId = getSelectedVariantId();
  var variantUrl = variantId && variantWaiverMap[variantId] ? variantWaiverMap[variantId] : '';
  var activeUrl = variantUrl || productWaiver || '';
  variantUrl = normalizeUrl(variantUrl);
  activeUrl = normalizeUrl(activeUrl);
  var taggedUrl = buildTaggedUrl(activeUrl, variantId);
  return {
    variantId: variantId,
    variantUrl: variantUrl,
    productUrl: productWaiver,
    activeUrl: activeUrl,
    taggedUrl: taggedUrl
  };
}

var state = {
  activeUrl: '',
  taggedUrl: '',
  sessionId: '',
  sessionRequest: null,
  cartSessionVariantId: null,
  cartSessionRequest: null,
  cartQuantity: 0,
  cartSessionId: '',
  cartParticipantEmails: [],
  cartParticipantPhones: [],
  participantName: '',
  participantEmail: '',
  participantPhone: '',
  participantPromptOpen: false,
  statusSigned: false,
  statusChecked: false,
  statusErrorMessage: '',
  statusRequest: null,
  statusRateLimited: false,
  statusRateLimitRetryAfter: 0,
  statusCheckedAt: 0,
  waitingStartedAt: 0,
  waitingForWaiver: false,
  waitingMessageTimer: null,
  waitingPollTimer: null,
  reusedStoredSession: false,
  variantId: null,
  pendingForm: null,
  pendingButton: null,
  pendingAction: null,
  bypass: false,
  fullscreen: true,
  mobileFocus: false
};

var sessionStorageTtlMs = 7 * 24 * 60 * 60 * 1000;

function hasSessionEndpoint() {
  return !!settings.sessionEndpoint;
}

function hasStatusEndpoint() {
  return !!settings.statusEndpoint;
}

function isRelativeEndpoint(endpoint) {
  if (!endpoint) return false;
  return !/^https?:\/\//i.test(endpoint) && !/^\/\//.test(endpoint);
}

function hasEndpointMisconfiguration() {
  return isRelativeEndpoint(settings.sessionEndpoint) || isRelativeEndpoint(settings.statusEndpoint);
}

function getEndpointOrigin(endpoint) {
  if (!endpoint) return '';
  try {
    return new URL(endpoint).origin;
  } catch (err) {
    return '';
  }
}

function isAllowedOrigin(origin) {
  if (!origin) return false;
  if (origin === window.location.origin) return true;
  var sessionOrigin = getEndpointOrigin(settings.sessionEndpoint);
  var statusOrigin = getEndpointOrigin(settings.statusEndpoint);
  return origin === sessionOrigin || origin === statusOrigin;
}

function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

function normalizePhone(value) {
  var digits = String(value || '').replace(/\D/g, '');
  if (digits.length > 10 && digits.charAt(0) === '1') {
    digits = digits.slice(1);
  }
  return digits;
}

function getSessionStorageKey(variantId) {
  if (!variantId || !productId) return '';
  return 'waiverGateSession:' + productId + ':' + variantId;
}

function getParticipantStorageKey(variantId) {
  if (!variantId || !productId) return '';
  return 'waiverGateParticipant:' + productId + ':' + variantId;
}

function loadStoredSession(variantId) {
  if (!variantId || settings.allowMultipleSessions) return '';
  try {
    if (!window.localStorage) return '';
    var key = getSessionStorageKey(variantId);
    if (!key) return '';
    var raw = window.localStorage.getItem(key);
    if (!raw) return '';
    var data = JSON.parse(raw);
    if (!data || !data.sessionId) return '';
    if (data.savedAt && Date.now() - data.savedAt > sessionStorageTtlMs) {
      window.localStorage.removeItem(key);
      return '';
    }
    return String(data.sessionId);
  } catch (err) {
    return '';
  }
}

function loadStoredParticipant(variantId) {
  if (!variantId || !settings.allowMultipleSessions) return null;
  try {
    if (!window.localStorage) return null;
    var key = getParticipantStorageKey(variantId);
    if (!key) return null;
    var raw = window.localStorage.getItem(key);
    if (!raw) return null;
    var data = JSON.parse(raw);
    if (!data || !data.name || !data.email || !data.phone) return null;
    if (data.savedAt && Date.now() - data.savedAt > sessionStorageTtlMs) {
      window.localStorage.removeItem(key);
      return null;
    }
    return data;
  } catch (err) {
    return null;
  }
}

function saveStoredSession(variantId, sessionId) {
  if (!variantId || !sessionId || settings.allowMultipleSessions) return;
  try {
    if (!window.localStorage) return;
    var key = getSessionStorageKey(variantId);
    if (!key) return;
    var payload = JSON.stringify({ sessionId: String(sessionId), savedAt: Date.now() });
    window.localStorage.setItem(key, payload);
  } catch (err) {
    // ignore storage errors
  }
}

function saveStoredParticipant(variantId, data) {
  if (!variantId || !settings.allowMultipleSessions || !data) return;
  try {
    if (!window.localStorage) return;
    var key = getParticipantStorageKey(variantId);
    if (!key) return;
    var payload = JSON.stringify({
      name: String(data.name || '').trim(),
      email: String(data.email || '').trim(),
      phone: String(data.phone || '').trim(),
      savedAt: Date.now()
    });
    window.localStorage.setItem(key, payload);
  } catch (err) {
    // ignore storage errors
  }
}

function clearStoredSession(variantId) {
  if (!variantId) return;
  try {
    if (!window.localStorage) return;
    var key = getSessionStorageKey(variantId);
    if (key) window.localStorage.removeItem(key);
  } catch (err) {
    // ignore storage errors
  }
}

function clearStoredParticipant(variantId) {
  if (!variantId || !settings.allowMultipleSessions) return;
  try {
    if (!window.localStorage) return;
    var key = getParticipantStorageKey(variantId);
    if (key) window.localStorage.removeItem(key);
  } catch (err) {
    // ignore storage errors
  }
}

function requestSessionId() {
  if (!hasSessionEndpoint() || hasEndpointMisconfiguration()) {
    return Promise.resolve('');
  }
  if (state.sessionId) {
    return Promise.resolve(state.sessionId);
  }
  if (state.sessionRequest) {
    return state.sessionRequest;
  }

  state.sessionRequest = fetch(settings.sessionEndpoint, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sectionId: sectionId,
      productId: productId,
      variantId: state.variantId || ''
    })
  })
    .then(function(res) { return res.ok ? res.json() : null; })
    .then(function(data) {
      var sessionId = data && (data.sessionId || data.session_id) ? String(data.sessionId || data.session_id) : '';
      if (sessionId) {
        state.sessionId = sessionId;
        state.statusChecked = false;
        state.statusSigned = false;
        state.reusedStoredSession = false;
        saveStoredSession(state.variantId, sessionId);
        updateUI();
      }
      return state.sessionId;
    })
    .catch(function() {
      return '';
    })
    .finally(function() {
      state.sessionRequest = null;
    });

  return state.sessionRequest;
}

function syncSessionFromCart(variantId) {
  if (!variantId) {
    return Promise.resolve('');
  }
  var desiredVariantId = String(variantId);
  if (state.sessionId && state.cartSessionVariantId === desiredVariantId) {
    return Promise.resolve(state.sessionId);
  }
  if (state.cartSessionRequest) {
    return state.cartSessionRequest;
  }

  state.cartSessionRequest = fetch('/cart.js', {
    method: 'GET',
    credentials: 'same-origin'
  })
    .then(function(res) { return res.ok ? res.json() : null; })
    .then(function(cart) {
      var sessionId = '';
      var quantity = 0;
      var participantEmails = [];
      var participantPhones = [];
      var emailKey = settings.participantEmailPropertyLabel || 'Waiver Participant Email';
      var phoneKey = settings.participantPhonePropertyLabel || 'Waiver Participant Phone';
      if (cart && Array.isArray(cart.items)) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (!item) continue;
          if (item.properties && typeof item.properties === 'object') {
            if (item.properties[emailKey]) {
              var normalizedEmail = normalizeEmail(item.properties[emailKey]);
              if (normalizedEmail) participantEmails.push(normalizedEmail);
            }
            if (item.properties[phoneKey]) {
              var normalizedPhone = normalizePhone(item.properties[phoneKey]);
              if (normalizedPhone) participantPhones.push(normalizedPhone);
            }
          }
          if (String(item.variant_id) !== desiredVariantId) continue;
          quantity += Number(item.quantity || 0);
          if (item.properties && item.properties['Waiver Session']) {
            sessionId = String(item.properties['Waiver Session']).trim();
          }
        }
      }

      state.cartSessionVariantId = desiredVariantId;
      state.cartQuantity = quantity;
      state.cartSessionId = sessionId || '';
      state.cartParticipantEmails = participantEmails;
      state.cartParticipantPhones = participantPhones;
      updateRootWarning();
      updateDebugPanel();

      if (!settings.allowMultipleSessions && sessionId && sessionId !== state.sessionId) {
        state.sessionId = sessionId;
        state.sessionRequest = null;
        state.statusRequest = null;
        state.statusChecked = false;
        state.statusSigned = false;
        state.reusedStoredSession = false;
        saveStoredSession(desiredVariantId, sessionId);
        log('cart-session', { variantId: desiredVariantId, sessionId: sessionId });
        updateDebugPanel();
        refreshModalTargets();
      }

      return sessionId || '';
    })
    .catch(function() {
      state.cartSessionVariantId = desiredVariantId;
      state.cartQuantity = 0;
      state.cartSessionId = '';
      state.cartParticipantEmails = [];
      state.cartParticipantPhones = [];
      updateRootWarning();
      updateDebugPanel();
      return '';
    })
    .finally(function() {
      state.cartSessionRequest = null;
    });

  return state.cartSessionRequest;
}

function requestWaiverStatus(force) {
  if (!hasStatusEndpoint() || hasEndpointMisconfiguration()) {
    return Promise.resolve(false);
  }
  if (!state.sessionId) {
    return Promise.resolve(false);
  }
  if (state.statusSigned && !force) {
    return Promise.resolve(true);
  }
  if (state.statusRequest) {
    return state.statusRequest;
  }
  state.statusRateLimited = false;
  state.statusRateLimitRetryAfter = 0;
  state.statusCheckedAt = 0;
  state.statusErrorMessage = '';

  var url = settings.statusEndpoint;
  try {
    var parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('sessionId', state.sessionId);
    url = parsed.toString();
  } catch (err) {
    url = settings.statusEndpoint + (settings.statusEndpoint.indexOf('?') === -1 ? '?' : '&') + 'sessionId=' + encodeURIComponent(state.sessionId);
  }

  var timeoutMs = parseInt(settings.verificationTimeoutMs, 10);
  if (isNaN(timeoutMs) || timeoutMs < 2000) {
    timeoutMs = 10000;
  }

  state.statusRequest = fetchWithTimeout(url, {
    method: 'GET',
    credentials: 'same-origin'
  }, timeoutMs)
    .then(function(res) {
      if (!res) return null;
      if (res.status === 429) {
        state.statusRateLimited = true;
        var retryHeader = res.headers && res.headers.get ? res.headers.get('Retry-After') : null;
        var retrySeconds = retryHeader ? parseInt(retryHeader, 10) : 0;
        if (!isNaN(retrySeconds) && retrySeconds > 0) {
          state.statusRateLimitRetryAfter = retrySeconds * 1000;
        }
        return null;
      }
      if (!res.ok) {
        state.statusErrorMessage = 'We could not verify your waiver yet. Please try again.';
        return null;
      }
      return res.json();
    })
    .then(function(data) {
      if (state.statusRateLimited) {
        state.statusChecked = true;
        state.statusSigned = false;
        state.statusCheckedAt = Date.now();
        updateStatusLine();
        updateContinueState();
        updateDebugPanel();
        return false;
      }
      var signed = !!(data && data.signed);
      state.statusChecked = true;
      state.statusSigned = signed;
      state.statusCheckedAt = Date.now();
      if (signed) {
        state.statusErrorMessage = '';
      } else if (!state.statusErrorMessage) {
        state.statusErrorMessage = '';
      }
      updateStatusLine();
      updateContinueState();
      updateDebugPanel();
      return state.statusSigned;
    })
    .catch(function(err) {
      state.statusChecked = true;
      state.statusSigned = false;
      state.statusCheckedAt = Date.now();
      if (err && err.name === 'AbortError') {
        state.statusErrorMessage = 'Verification timed out. Please try again.';
      } else if (!state.statusErrorMessage) {
        state.statusErrorMessage = 'We could not reach the verification server. Please try again.';
      }
      updateStatusLine();
      updateContinueState();
      return false;
    })
    .finally(function() {
      state.statusRequest = null;
    });

  updateStatusLine();
  return state.statusRequest;
}

function wait(ms) {
  return new Promise(function(resolve) {
    window.setTimeout(resolve, ms);
  });
}

function fetchWithTimeout(url, options, timeoutMs) {
  if (typeof AbortController === 'undefined') {
    return fetch(url, options);
  }
  var controller = new AbortController();
  var timer = window.setTimeout(function() {
    controller.abort();
  }, timeoutMs);
  var opts = Object.assign({}, options, { signal: controller.signal });
  return fetch(url, opts).finally(function() {
    window.clearTimeout(timer);
  });
}

function clearWaitingTimers() {
  if (state.waitingMessageTimer) {
    window.clearInterval(state.waitingMessageTimer);
    state.waitingMessageTimer = null;
  }
  if (state.waitingPollTimer) {
    window.clearTimeout(state.waitingPollTimer);
    state.waitingPollTimer = null;
  }
}

function isModalOpen() {
  var modal = document.getElementById(modalId);
  return !!(modal && modal.getAttribute('data-open') === 'true');
}

function updateContinueState() {
  var modal = document.getElementById(modalId);
  if (!modal) return;
  var btn = modal.querySelector('[data-waiver-continue]');
  var textEl = btn ? btn.querySelector('.waiver-gate-continue-text') : null;
  function setText(value) {
    if (textEl) {
      textEl.textContent = value;
    } else if (btn) {
      btn.textContent = value;
    }
  }
  if (btn) {
    if (state.waitingForWaiver) {
      setText('Checking waiver');
      btn.disabled = true;
      btn.setAttribute('data-busy', 'true');
      return;
    }
    if (!hasStatusEndpoint()) {
      setText(settings.continueLabel);
      btn.disabled = false;
      btn.setAttribute('data-busy', 'false');
      return;
    }
    if (state.statusRequest) {
      setText('Checking waiver');
      btn.disabled = true;
      btn.setAttribute('data-busy', 'true');
      return;
    }
    if (state.statusSigned) {
      setText(settings.continueLabel);
      btn.disabled = false;
      btn.setAttribute('data-busy', 'false');
      return;
    }
    setText(settings.checkboxLabel || 'I have completed the waiver.');
    btn.disabled = false;
    btn.setAttribute('data-busy', 'false');
  }
}

function updateStatusLine(forcedMessage, forcedState) {
  var modal = document.getElementById(modalId);
  if (!modal) return;
  var line = modal.querySelector('[data-waiver-status-line]');
  if (!line) return;

  if (forcedMessage) {
    line.textContent = forcedMessage;
    if (forcedState) {
      line.setAttribute('data-state', forcedState);
    }
    updateContinueState();
    return;
  }

  if (state.waitingForWaiver) {
    line.textContent = '';
    line.setAttribute('data-state', 'idle');
    updateContinueState();
    return;
  }
  if (state.statusSigned) {
    line.textContent = 'Waiver confirmed. You can continue.';
    line.setAttribute('data-state', 'success');
    updateContinueState();
    return;
  }
  if (state.statusErrorMessage) {
    line.textContent = state.statusErrorMessage;
    line.setAttribute('data-state', 'error');
    updateContinueState();
    return;
  }
  if (state.statusRateLimited) {
    line.textContent = 'Too many checks right now. Please wait and try again.';
    line.setAttribute('data-state', 'error');
    updateContinueState();
    return;
  }
  if (state.statusRequest) {
    line.textContent = 'Checking waiver...';
    line.setAttribute('data-state', 'loading');
    updateContinueState();
    return;
  }
  if (state.statusChecked) {
    var notice = settings.verificationWaitNotice || 'If you just submitted, it can take up to a minute to verify.';
    line.textContent = 'We have not received your waiver yet. ' + notice;
    line.setAttribute('data-state', 'error');
    updateContinueState();
    return;
  }

  line.textContent = settings.checkboxHint || 'Waiting for waiver submission...';
  line.setAttribute('data-state', 'idle');
  updateContinueState();
}

var updateTimer = null;
function scheduleUpdateUI() {
  if (updateTimer) return;
  updateTimer = window.setTimeout(function() {
    updateTimer = null;
    updateUI();
  }, 80);
}

function updateUI() {
  var info = getActiveInfo();
  state.variantId = info.variantId;
  state.activeUrl = info.activeUrl;
  state.taggedUrl = info.taggedUrl;

  var hasActive = !!info.activeUrl;
  var hasBuyNow = !!getBuyNowButton();
  if (hasActive && state.variantId) {
    if (!settings.allowMultipleSessions && !state.sessionId) {
      var storedSession = loadStoredSession(state.variantId);
      if (storedSession) {
        state.sessionId = storedSession;
        state.statusChecked = false;
        state.statusSigned = false;
        state.reusedStoredSession = true;
        log('stored-session', { variantId: state.variantId, sessionId: storedSession });
      }
    }
    syncSessionFromCart(state.variantId).then(function(foundSession) {
      if (!foundSession && !state.sessionId) {
        requestSessionId();
        return;
      }
    });
  }
  var wrap = root.querySelector('[data-waiver-button-wrap]');
  if (wrap) {
    wrap.style.display = hasActive && settings.showButton ? 'inline-flex' : 'none';
  }
  var button = root.querySelector('[data-waiver-button]');
  if (button) {
    button.setAttribute('href', hasActive ? state.taggedUrl : '#');
  }
  var badge = root.querySelector('[data-waiver-debug]');
  if (badge) {
    if (settings.debug) {
      badge.style.display = 'inline-block';
      badge.textContent = 'variant: ' + (info.variantId || 'none') + ' | active: ' + (hasActive ? 'yes' : 'no');
    } else {
      badge.style.display = 'none';
    }
  }
  updateRootWarning(hasActive, hasBuyNow);

  log('update', {
    containerFound: !!container,
    formFound: !!getForm(),
    buyNowFound: hasBuyNow,
    variantId: info.variantId,
    variantWaiverUrl: info.variantUrl,
    productWaiverUrl: info.productUrl,
    activeWaiverUrl: info.activeUrl,
    taggedWaiverUrl: info.taggedUrl
  });

  placeButton(hasActive);
  toggleAddToCartClass(hasActive && settings.disableAddToCart && hasBuyNow);
  toggleQuantityClass(hasActive);
  refreshModalTargets();
  updateDebugPanel();
}

function updateRootWarning(hasActive, hasBuyNow) {
  var warning = root.querySelector('[data-waiver-warning]');
  if (!warning) return;
  var active = typeof hasActive === 'boolean' ? hasActive : !!state.activeUrl;
  var buyNow = typeof hasBuyNow === 'boolean' ? hasBuyNow : !!getBuyNowButton();
  if (active && hasEndpointMisconfiguration()) {
    warning.style.display = 'block';
    warning.textContent = 'Waiver endpoints look misconfigured. Use full URLs for the session and status endpoints (https://...).';
    return;
  }
  if (!settings.allowMultipleSessions && active && state.cartQuantity > 0) {
    warning.style.display = 'block';
    warning.textContent = settings.cartLimitMessage || 'This item is already in your cart. Only one is allowed.';
    return;
  }
  if (active && settings.disableAddToCart && !buyNow) {
    warning.style.display = 'block';
    warning.textContent = 'Buy it now is not available here, so Add to cart remains enabled.';
    return;
  }
  warning.style.display = 'none';
  warning.textContent = '';
}

function placeButton(hasActive) {
  if (!hasActive || !settings.showButton) return;
  if (!container) return;
  var form = getForm();
  if (!form) return;
  var submitButton = form.querySelector('button[name="add"], input[name="add"], button[data-add-to-cart], button[id*="AddToCart"]');
  if (!submitButton) {
    submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
  }
  if (!submitButton) return;
  var targetParent = submitButton.parentNode;
  if (!targetParent) return;
  if (root.parentNode !== targetParent || root.nextElementSibling !== submitButton) {
    targetParent.insertBefore(root, submitButton);
  }
}

function isBuyNowButton(button) {
  if (!button) return false;
  if (button.matches && button.matches('[name="checkout"], [data-testid="Checkout-button"], .shopify-payment-button__button')) {
    return true;
  }
  if (button.getAttribute && button.getAttribute('name') === 'checkout') {
    return true;
  }
  if (button.closest && button.closest('.shopify-payment-button')) {
    return true;
  }
  return false;
}

function toggleAddToCartClass(disable) {
  if (!container) return;
  if (disable) {
    container.classList.add('waiver-gate-disable-atc');
  } else {
    container.classList.remove('waiver-gate-disable-atc');
  }
}

function toggleQuantityClass(disable) {
  if (!container) return;
  if (disable) {
    container.classList.add('waiver-gate-disable-qty');
  } else {
    container.classList.remove('waiver-gate-disable-qty');
  }
}

function ensureModal() {
  var existing = document.getElementById(modalId);
  if (existing) return existing;

  var modal = document.createElement('div');
  modal.id = modalId;
  modal.className = 'waiver-gate-modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-hidden', 'true');

  var backdrop = document.createElement('div');
  backdrop.className = 'waiver-gate-backdrop';
  backdrop.setAttribute('data-waiver-close', '');

  var dialog = document.createElement('div');
  dialog.className = 'waiver-gate-dialog';
  dialog.setAttribute('role', 'document');

  var closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'waiver-gate-close';
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.setAttribute('data-waiver-close', '');
  closeBtn.textContent = 'x';

  var toggleBtn = document.createElement('button');
  toggleBtn.type = 'button';
  toggleBtn.className = 'waiver-gate-toggle';
  toggleBtn.setAttribute('data-waiver-toggle', '');
  toggleBtn.setAttribute('data-mode', 'exit');
  toggleBtn.innerHTML = '<span class=\"waiver-gate-toggle-icon\" aria-hidden=\"true\"></span>' +
    '<span class=\"waiver-gate-toggle-text\">Exit full screen</span>';

  var title = document.createElement('h2');
  title.className = 'waiver-gate-title';
  title.textContent = settings.modalTitle;

  var body = document.createElement('p');
  body.className = 'waiver-gate-body';
  body.textContent = settings.modalBody;

  var iframe = document.createElement('iframe');
  iframe.className = 'waiver-gate-iframe';
  iframe.setAttribute('data-waiver-iframe', '');
  iframe.setAttribute('loading', 'lazy');
  iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
  iframe.setAttribute('title', 'Waiver form');
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('webkitallowfullscreen', '');
  iframe.setAttribute('mozallowfullscreen', '');
  iframe.setAttribute('allow', 'fullscreen');

  var iframeWrap = document.createElement('div');
  iframeWrap.className = 'waiver-gate-iframe-wrap';

  var overlay = document.createElement('div');
  overlay.className = 'waiver-gate-overlay';
  overlay.setAttribute('data-waiver-overlay', '');
  overlay.setAttribute('data-state', 'hidden');

  var overlayCard = document.createElement('div');
  overlayCard.className = 'waiver-gate-overlay-card';

  var overlayDots = document.createElement('div');
  overlayDots.className = 'waiver-gate-dots';
  overlayDots.innerHTML =
    '<span class="waiver-gate-dot"></span>' +
    '<span class="waiver-gate-dot"></span>' +
    '<span class="waiver-gate-dot"></span>';

  var overlayText = document.createElement('span');
  overlayText.setAttribute('data-waiver-overlay-text', '');
  overlayText.textContent = 'Waiting for your waiver...';

  var overlayActions = document.createElement('div');
  overlayActions.className = 'waiver-gate-overlay-actions';

  var overlayTry = document.createElement('button');
  overlayTry.type = 'button';
  overlayTry.className = 'waiver-gate-overlay-try';
  overlayTry.setAttribute('data-waiver-overlay-try', '');
  overlayTry.textContent = settings.tryAgainLabel || 'Try again';

  var overlayCancel = document.createElement('button');
  overlayCancel.type = 'button';
  overlayCancel.className = 'waiver-gate-overlay-cancel';
  overlayCancel.setAttribute('data-waiver-overlay-cancel', '');
  overlayCancel.textContent = settings.cancelLabel || 'Cancel';

  overlayActions.appendChild(overlayTry);
  overlayActions.appendChild(overlayCancel);

  overlayCard.appendChild(overlayDots);
  overlayCard.appendChild(overlayText);
  overlayCard.appendChild(overlayActions);
  overlay.appendChild(overlayCard);
  iframeWrap.appendChild(iframe);
  iframeWrap.appendChild(overlay);

  var steps = document.createElement('div');
  steps.className = 'waiver-gate-steps';
  steps.textContent =
    'Step 1: Open and submit the waiver · Step 2: Tap "' +
    (settings.checkboxLabel || 'I have completed the waiver.') +
    '" · Step 3: Continue to checkout';

  var statusLine = document.createElement('div');
  statusLine.className = 'waiver-gate-status';
  statusLine.setAttribute('data-waiver-status-line', '');
  statusLine.setAttribute('data-state', 'idle');
  statusLine.textContent = settings.checkboxHint || 'Waiting for waiver submission...';

  var debugPanel = document.createElement('div');
  debugPanel.className = 'waiver-gate-debug-panel';
  debugPanel.setAttribute('data-waiver-debug-panel', '');
  debugPanel.innerHTML =
    '<div class="waiver-gate-debug-header">' +
      '<strong>Waiver Gate Debug</strong>' +
      '<button type="button" class="waiver-gate-debug-toggle" data-waiver-debug-toggle>Hide details</button>' +
    '</div>' +
    '<div class="waiver-gate-debug-body">' +
      '<div>Session endpoint: <span data-waiver-debug-endpoint></span></div>' +
      '<div>Session id: <span data-waiver-debug-session></span></div>' +
      '<div>Session reused: <span data-waiver-debug-session-reused></span></div>' +
      '<div>Status endpoint: <span data-waiver-debug-status-endpoint></span></div>' +
      '<div>Signed status: <span data-waiver-debug-signed></span></div>' +
      '<div>Rate limited: <span data-waiver-debug-ratelimit></span></div>' +
      '<div>Status checked: <span data-waiver-debug-checked></span></div>' +
      '<div>Variant id: <span data-waiver-debug-variant></span></div>' +
      '<div>Cart quantity: <span data-waiver-debug-cartqty></span></div>' +
      '<div>Cart session: <span data-waiver-debug-cartsession></span></div>' +
      '<div>Participant: <span data-waiver-debug-participant></span></div>' +
      '<div>Participant email: <span data-waiver-debug-participant-email></span></div>' +
      '<div>Participant phone: <span data-waiver-debug-participant-phone></span></div>' +
      '<div>Buy now present: <span data-waiver-debug-buynow></span></div>' +
      '<div>Active URL: <span data-waiver-debug-active></span></div>' +
      '<div>Tagged URL: <span data-waiver-debug-tagged></span></div>' +
    '</div>';

  var actions = document.createElement('div');
  actions.className = 'waiver-gate-actions';

  var agreeHint = document.createElement('div');
  agreeHint.className = 'waiver-gate-agree-hint';
  agreeHint.textContent = '**IMPORTANT** Tap "Agree to This Document" at the end of the waiver before this button.';

  var continueBtn = document.createElement('button');
  continueBtn.type = 'button';
  continueBtn.className = 'waiver-gate-continue';
  continueBtn.setAttribute('data-waiver-continue', '');
  continueBtn.setAttribute('data-busy', 'false');

  var continueText = document.createElement('span');
  continueText.className = 'waiver-gate-continue-text';
  continueText.textContent = settings.checkboxLabel || 'I have completed the waiver.';

  var continueSpinner = document.createElement('span');
  continueSpinner.className = 'waiver-gate-continue-spinner';
  continueSpinner.setAttribute('aria-hidden', 'true');
  continueSpinner.innerHTML =
    '<span class="waiver-gate-dot"></span>' +
    '<span class="waiver-gate-dot"></span>' +
    '<span class="waiver-gate-dot"></span>';

  continueBtn.appendChild(continueText);
  continueBtn.appendChild(continueSpinner);

  var cancelBtn = document.createElement('button');
  cancelBtn.type = 'button';
  cancelBtn.className = 'waiver-gate-cancel';
  cancelBtn.setAttribute('data-waiver-cancel', '');
  cancelBtn.setAttribute('data-waiver-close', '');
  cancelBtn.textContent = settings.cancelLabel;

  actions.appendChild(continueBtn);
  actions.appendChild(cancelBtn);

  var header = document.createElement('div');
  header.className = 'waiver-gate-header';

  var headerActions = document.createElement('div');
  headerActions.className = 'waiver-gate-header-actions';
  headerActions.appendChild(toggleBtn);
  headerActions.appendChild(closeBtn);

  header.appendChild(title);
  header.appendChild(headerActions);

  dialog.appendChild(header);
  dialog.appendChild(body);
  dialog.appendChild(buildParticipantPrompt());
  dialog.appendChild(iframeWrap);
  dialog.appendChild(steps);
  dialog.appendChild(statusLine);
  dialog.appendChild(agreeHint);
  dialog.appendChild(debugPanel);
  dialog.appendChild(actions);

  debugPanel.setAttribute('data-collapsed', 'false');
  var debugToggle = debugPanel.querySelector('[data-waiver-debug-toggle]');
  if (debugToggle) {
    debugToggle.addEventListener('click', function() {
      var collapsed = debugPanel.getAttribute('data-collapsed') === 'true';
      debugPanel.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      debugToggle.textContent = collapsed ? 'Hide details' : 'Show details';
    });
  }

  modal.appendChild(backdrop);
  modal.appendChild(dialog);
  document.body.appendChild(modal);

  iframe.addEventListener('load', function() {
    log('iframe-loaded', { src: iframe.getAttribute('src') });
  });

  toggleBtn.addEventListener('click', function() {
    if (isMobileViewport()) {
      setMobileFocus(!state.mobileFocus);
      return;
    }
    setFullscreen(!state.fullscreen);
  });

  function resetOverlayState() {
    modal.removeAttribute('data-waiting');
    overlay.setAttribute('data-state', 'hidden');
    overlayText.textContent = '';
  }

  function verifyWaiver(proceedOnSuccess) {
    var modal = ensureModal();
    var overlayEl = modal.querySelector('[data-waiver-overlay]');
    var overlayTextEl = overlayEl ? overlayEl.querySelector('[data-waiver-overlay-text]') : null;

    function showOverlay(message, stateName, keepWaiting) {
      if (!overlayEl) return;
      var stateValue = stateName || 'loading';
      if (keepWaiting) {
        modal.setAttribute('data-waiting', 'true');
      } else {
        modal.removeAttribute('data-waiting');
      }
      overlayEl.setAttribute('data-state', stateValue);
      if (overlayTextEl) {
        overlayTextEl.textContent = message || 'Waiting for your waiver...';
      }
    }

    function hideOverlay() {
      if (!overlayEl) return;
      modal.removeAttribute('data-waiting');
      overlayEl.setAttribute('data-state', 'hidden');
      if (overlayTextEl) {
        overlayTextEl.textContent = '';
      }
    }

    function proceedToCheckout() {
      state.waitingForWaiver = false;
      clearWaitingTimers();
      hideOverlay();
      state.bypass = true;
      var targetForm = state.pendingForm || getForm();
      closeModal();

      var directToCheckout = settings.directToCheckout === true;
      if (!directToCheckout) {
        if (targetForm) {
          ensureLineItemProperty(targetForm);
          var existingCheckout = targetForm.querySelector('input[name="checkout"]');
          if (existingCheckout && existingCheckout.parentElement) {
            existingCheckout.parentElement.removeChild(existingCheckout);
          }
          try {
            targetForm.requestSubmit();
          } catch (err) {
            targetForm.submit();
          }
        } else if (state.pendingButton) {
          try {
            state.pendingButton.click();
          } catch (err) {}
        }
        state.pendingForm = null;
        state.pendingButton = null;
        state.pendingAction = null;
        return;
      }

      if (targetForm) {
        ensureLineItemProperty(targetForm);
        var formData = new FormData(targetForm);
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function(res) {
            if (!res.ok) throw new Error('cart add failed');
            return res.json();
          })
          .then(function() {
            window.location.href = '/checkout';
          })
          .catch(function() {
            try {
              targetForm.submit();
            } catch (err) {
              if (state.pendingButton) state.pendingButton.click();
            }
          });
      } else if (state.pendingButton) {
        state.pendingButton.click();
      }

      state.pendingForm = null;
      state.pendingButton = null;
      state.pendingAction = null;
    }

    if (proceedOnSuccess && state.statusSigned) {
      proceedToCheckout();
      return;
    }

    if (state.waitingForWaiver) {
      return;
    }

    state.waitingForWaiver = true;
    state.waitingStartedAt = Date.now();
    clearWaitingTimers();

    var waitNotice = settings.verificationWaitNotice || 'This can take a minute.';
    var waitingMessages = [
      'Waiting for your waiver...',
      'Still checking...',
      waitNotice,
      'Thanks for your patience...'
    ].filter(Boolean);

    var messageIndex = 0;
    showOverlay(waitingMessages[messageIndex], 'loading', true);
    updateStatusLine('Waiting for your waiver...', 'loading');
    updateContinueState();

    if (overlayTextEl && waitingMessages.length > 1) {
      state.waitingMessageTimer = window.setInterval(function() {
        if (!state.waitingForWaiver) return;
        messageIndex = (messageIndex + 1) % waitingMessages.length;
        overlayTextEl.textContent = waitingMessages[messageIndex];
      }, 5000);
    }

    function scheduleNextCheck(delayMs) {
      if (!state.waitingForWaiver) return;
      clearWaitingTimers();
      if (overlayTextEl && waitingMessages.length > 1) {
        state.waitingMessageTimer = window.setInterval(function() {
          if (!state.waitingForWaiver) return;
          messageIndex = (messageIndex + 1) % waitingMessages.length;
          overlayTextEl.textContent = waitingMessages[messageIndex];
        }, 5000);
      }
      state.waitingPollTimer = window.setTimeout(checkStatus, delayMs);
    }

    function getDelayMs() {
      var delayMs = parseInt(settings.verificationDelayMs, 10);
      if (isNaN(delayMs) || delayMs < 1000) delayMs = 6000;
      return delayMs;
    }

    function getMaxWaitMs() {
      var maxMs = parseInt(settings.verificationMaxWaitMs, 10);
      if (isNaN(maxMs) || maxMs < 15000) {
        maxMs = 90000;
      }
      return maxMs;
    }

    function checkStatus() {
      if (!state.waitingForWaiver) return;
      if (state.waitingStartedAt && Date.now() - state.waitingStartedAt > getMaxWaitMs()) {
        state.waitingForWaiver = false;
        clearWaitingTimers();
        showOverlay('We have not received your waiver yet. Try again in a moment.', 'timeout', false);
        updateStatusLine('We have not received your waiver yet. You can try again.', 'error');
        updateContinueState();
        return;
      }
      var ensureSession = hasSessionEndpoint() && !state.sessionId
        ? requestSessionId()
        : Promise.resolve(state.sessionId || '');

      ensureSession.then(function(sessionId) {
        if (hasSessionEndpoint() && !sessionId) {
          scheduleNextCheck(getDelayMs());
          return;
        }
        if (!hasStatusEndpoint()) {
          proceedToCheckout();
          return;
        }
        requestWaiverStatus(true).then(function(signed) {
          if (signed) {
            updateStatusLine('Waiver confirmed. You can continue.', 'success');
            proceedToCheckout();
            return;
          }
          var delayMs = getDelayMs();
          if (state.statusRateLimited && state.statusRateLimitRetryAfter) {
            delayMs = state.statusRateLimitRetryAfter;
          }
          scheduleNextCheck(delayMs);
        }).catch(function() {
          scheduleNextCheck(getDelayMs());
        });
      }).catch(function() {
        scheduleNextCheck(getDelayMs());
      });
    }

    checkStatus();
  }

  overlayTry.addEventListener('click', function() {
    state.waitingForWaiver = false;
    clearWaitingTimers();
    resetOverlayState();
    updateStatusLine();
    updateContinueState();
    verifyWaiver(true);
  });

  overlayCancel.addEventListener('click', function() {
    state.waitingForWaiver = false;
    clearWaitingTimers();
    resetOverlayState();
    updateStatusLine();
    updateContinueState();
  });

  continueBtn.addEventListener('click', function() {
    verifyWaiver(true);
  });

  var closeButtons = modal.querySelectorAll('[data-waiver-close]');
  for (var i = 0; i < closeButtons.length; i++) {
    closeButtons[i].addEventListener('click', function() {
      closeModal();
    });
  }

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  return modal;
}

function updateDebugPanel() {
  if (!settings.debug) return;
  var modal = ensureModal();
  modal.setAttribute('data-debug', 'true');
  var panel = modal.querySelector('[data-waiver-debug-panel]');
  if (!panel) return;

  var endpointEl = panel.querySelector('[data-waiver-debug-endpoint]');
  var sessionEl = panel.querySelector('[data-waiver-debug-session]');
  var sessionReusedEl = panel.querySelector('[data-waiver-debug-session-reused]');
  var statusEndpointEl = panel.querySelector('[data-waiver-debug-status-endpoint]');
  var signedEl = panel.querySelector('[data-waiver-debug-signed]');
  var rateLimitEl = panel.querySelector('[data-waiver-debug-ratelimit]');
  var checkedEl = panel.querySelector('[data-waiver-debug-checked]');
  var variantEl = panel.querySelector('[data-waiver-debug-variant]');
  var cartQtyEl = panel.querySelector('[data-waiver-debug-cartqty]');
  var cartSessionEl = panel.querySelector('[data-waiver-debug-cartsession]');
  var participantEl = panel.querySelector('[data-waiver-debug-participant]');
  var participantEmailEl = panel.querySelector('[data-waiver-debug-participant-email]');
  var participantPhoneEl = panel.querySelector('[data-waiver-debug-participant-phone]');
  var buyNowEl = panel.querySelector('[data-waiver-debug-buynow]');
  var activeEl = panel.querySelector('[data-waiver-debug-active]');
  var taggedEl = panel.querySelector('[data-waiver-debug-tagged]');

  if (endpointEl) endpointEl.textContent = settings.sessionEndpoint || '(none)';
  if (sessionEl) {
    if (state.sessionId) sessionEl.textContent = state.sessionId;
    else if (state.sessionRequest) sessionEl.textContent = '(pending)';
    else sessionEl.textContent = '(none)';
  }
  if (sessionReusedEl) sessionReusedEl.textContent = state.reusedStoredSession ? 'yes' : 'no';
  if (statusEndpointEl) statusEndpointEl.textContent = settings.statusEndpoint || '(none)';
  if (signedEl) {
    if (!hasStatusEndpoint()) signedEl.textContent = '(status disabled)';
    else if (state.statusSigned) signedEl.textContent = 'signed';
    else if (state.statusRequest) signedEl.textContent = '(checking)';
    else if (state.statusChecked) signedEl.textContent = 'not signed';
    else signedEl.textContent = '(unknown)';
  }
  if (rateLimitEl) {
    if (state.statusRateLimited) {
      var retryText = state.statusRateLimitRetryAfter ? ('yes (' + Math.ceil(state.statusRateLimitRetryAfter / 1000) + 's)') : 'yes';
      rateLimitEl.textContent = retryText;
    } else {
      rateLimitEl.textContent = 'no';
    }
  }
  if (checkedEl) {
    if (state.statusCheckedAt) {
      try {
        checkedEl.textContent = new Date(state.statusCheckedAt).toLocaleTimeString();
      } catch (err) {
        checkedEl.textContent = String(state.statusCheckedAt);
      }
    } else {
      checkedEl.textContent = '(never)';
    }
  }
  if (variantEl) variantEl.textContent = state.variantId || '(none)';
  if (cartQtyEl) cartQtyEl.textContent = String(state.cartQuantity || 0);
  if (cartSessionEl) cartSessionEl.textContent = state.cartSessionId || '(none)';
  if (participantEl) participantEl.textContent = state.participantName || '(none)';
  if (participantEmailEl) participantEmailEl.textContent = state.participantEmail || '(none)';
  if (participantPhoneEl) participantPhoneEl.textContent = state.participantPhone || '(none)';
  if (buyNowEl) buyNowEl.textContent = getBuyNowButton() ? 'yes' : 'no';
  if (activeEl) activeEl.textContent = state.activeUrl || '(none)';
  if (taggedEl) taggedEl.textContent = state.taggedUrl || '(none)';
}

function refreshModalTargets() {
  var modal = document.getElementById(modalId);
  if (!modal || modal.getAttribute('data-open') !== 'true') return;
  var targetUrl = state.taggedUrl || state.activeUrl || '';
  if (requiresParticipantInfo()) {
    targetUrl = '';
  }
  var iframe = modal.querySelector('[data-waiver-iframe]');
  var overlayEl = modal.querySelector('[data-waiver-overlay]');
  var overlayTextEl = overlayEl ? overlayEl.querySelector('[data-waiver-overlay-text]') : null;

  if (iframe && targetUrl && iframe.getAttribute('src') !== targetUrl) {
    iframe.setAttribute('src', targetUrl);
  } else if (iframe && !targetUrl && iframe.getAttribute('src')) {
    iframe.setAttribute('src', '');
  }

  if (overlayEl && !state.statusRequest) {
    overlayEl.setAttribute('data-state', 'hidden');
    if (overlayTextEl) {
      overlayTextEl.textContent = '';
    }
  }

  updateDebugPanel();
}

function openModal() {
  var modal = ensureModal();
  var iframe = modal.querySelector('[data-waiver-iframe]');
  var statusLine = modal.querySelector('[data-waiver-status-line]');
  var overlayEl = modal.querySelector('[data-waiver-overlay]');
  var overlayTextEl = overlayEl ? overlayEl.querySelector('[data-waiver-overlay-text]') : null;
  var participantPanel = modal.querySelector('[data-waiver-participant-panel]');
  var participantInput = modal.querySelector('[data-waiver-participant-input]');
  var participantEmailInput = modal.querySelector('[data-waiver-participant-email]');
  var participantPhoneInput = modal.querySelector('[data-waiver-participant-phone]');
  var participantContinue = modal.querySelector('[data-waiver-participant-continue]');

  if (statusLine) updateStatusLine();
    if (settings.allowMultipleSessions) {
    var storedParticipant = loadStoredParticipant(state.variantId);
    state.participantName = storedParticipant ? String(storedParticipant.name || '') : '';
    state.participantEmail = storedParticipant ? String(storedParticipant.email || '') : '';
    state.participantPhone = storedParticipant ? String(storedParticipant.phone || '') : '';
    state.participantPromptOpen = true;
    if (participantInput) {
      participantInput.value = state.participantName;
    }
    if (participantEmailInput) {
      participantEmailInput.value = state.participantEmail;
    }
    if (participantPhoneInput) {
      participantPhoneInput.value = state.participantPhone;
    }
    if (participantContinue) {
      participantContinue.disabled = !(state.participantName && state.participantEmail && state.participantPhone);
    }
    setParticipantPromptOpen(true);
  } else {
    state.participantName = '';
    state.participantEmail = '';
    state.participantPhone = '';
    state.participantPromptOpen = false;
    setParticipantPromptOpen(false);
  }
  clearWaitingTimers();
  var targetUrl = state.taggedUrl || '';
  if (requiresParticipantInfo()) {
    targetUrl = '';
  }
  if (iframe) iframe.setAttribute('src', targetUrl);
  if (overlayEl) {
    overlayEl.setAttribute('data-state', 'hidden');
    if (overlayTextEl) {
      overlayTextEl.textContent = '';
    }
  }
  state.waitingForWaiver = false;
  modal.removeAttribute('data-waiting');
  if (!settings.debug) {
    modal.removeAttribute('data-debug');
  }
  setFullscreen(true);
  if (isMobileViewport()) {
    setMobileFocus(true);
  } else {
    setMobileFocus(false);
  }
  modal.setAttribute('data-open', 'true');
  modal.setAttribute('aria-hidden', 'false');
  log('modal-opened', { activeWaiverUrl: state.activeUrl });
  updateDebugPanel();

  if (settings.allowMultipleSessions && participantPanel && participantInput) {
    window.setTimeout(function() {
      try {
        participantInput.focus();
      } catch (err) {
        // no-op
      }
    }, 20);
  }

  if (hasSessionEndpoint() && !state.sessionId) {
    requestSessionId().then(function() {
      refreshModalTargets();
    });
  }
}

function closeModal() {
  var modal = document.getElementById(modalId);
  if (!modal) return;
  if (state.waitingForWaiver) return;
  modal.removeAttribute('data-open');
  modal.setAttribute('aria-hidden', 'true');
  modal.removeAttribute('data-mobile-focus');
  state.mobileFocus = false;
  state.waitingStartedAt = 0;
  clearWaitingTimers();
}

function isMobileViewport() {
  return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
}

function setFullscreen(enabled) {
  var modal = ensureModal();
  state.fullscreen = !!enabled;
  modal.setAttribute('data-fullscreen', state.fullscreen ? 'true' : 'false');
  var toggle = modal.querySelector('[data-waiver-toggle]');
  if (toggle) {
    var isExit = isMobileViewport() ? state.mobileFocus : state.fullscreen;
    toggle.setAttribute('data-mode', isExit ? 'exit' : 'enter');
    var textEl = toggle.querySelector('.waiver-gate-toggle-text');
    if (textEl) {
      textEl.textContent = isExit ? 'Exit full screen' : 'Full screen';
    }
    toggle.setAttribute('aria-label', isExit ? 'Exit full screen' : 'Full screen');
  }
}

function setMobileFocus(enabled) {
  var modal = ensureModal();
  state.mobileFocus = !!enabled;
  if (state.mobileFocus) {
    modal.setAttribute('data-mobile-focus', 'true');
  } else {
    modal.removeAttribute('data-mobile-focus');
  }
  var toggle = modal.querySelector('[data-waiver-toggle]');
  if (toggle) {
    toggle.setAttribute('data-mode', state.mobileFocus ? 'exit' : 'enter');
    var textEl = toggle.querySelector('.waiver-gate-toggle-text');
    if (textEl) {
      textEl.textContent = state.mobileFocus ? 'Exit full screen' : 'Full screen';
    }
    toggle.setAttribute('aria-label', state.mobileFocus ? 'Exit full screen' : 'Full screen');
  }
}

function ensureLineItemProperty(form) {
  if (!form) return;
  var label = settings.lineItemPropertyLabel || 'Waiver Completed';
  var fieldName = 'properties[' + label + ']';
  var legacy = form.querySelector('input[name="properties[Waiver Initiated]"]');
  if (legacy && legacy.name !== fieldName) {
    legacy.parentElement.removeChild(legacy);
  }
  var existing = form.querySelector('input[name="' + fieldName + '"]');
  if (!existing) {
    existing = document.createElement('input');
    existing.type = 'hidden';
    existing.name = fieldName;
    form.appendChild(existing);
  }
  existing.value = 'Yes';

  if (state.sessionId) {
    var sessionFieldName = 'properties[Waiver Session]';
    var sessionInput = form.querySelector('input[name="' + sessionFieldName + '"]');
    if (!sessionInput) {
      sessionInput = document.createElement('input');
      sessionInput.type = 'hidden';
      sessionInput.name = sessionFieldName;
      form.appendChild(sessionInput);
    }
    sessionInput.value = state.sessionId;
  }

  if (state.participantName) {
    var participantLabel = settings.participantPropertyLabel || 'Waiver Participant';
    var participantFieldName = 'properties[' + participantLabel + ']';
    var participantInput = form.querySelector('input[name="' + participantFieldName + '"]');
    if (!participantInput) {
      participantInput = document.createElement('input');
      participantInput.type = 'hidden';
      participantInput.name = participantFieldName;
      form.appendChild(participantInput);
    }
    participantInput.value = state.participantName;
  }

  if (state.participantEmail) {
    var participantEmailLabel = settings.participantEmailPropertyLabel || 'Waiver Participant Email';
    var participantEmailFieldName = 'properties[' + participantEmailLabel + ']';
    var participantEmailInput = form.querySelector('input[name="' + participantEmailFieldName + '"]');
    if (!participantEmailInput) {
      participantEmailInput = document.createElement('input');
      participantEmailInput.type = 'hidden';
      participantEmailInput.name = participantEmailFieldName;
      form.appendChild(participantEmailInput);
    }
    participantEmailInput.value = state.participantEmail;
  }

  if (state.participantPhone) {
    var participantPhoneLabel = settings.participantPhonePropertyLabel || 'Waiver Participant Phone';
    var participantPhoneFieldName = 'properties[' + participantPhoneLabel + ']';
    var participantPhoneInput = form.querySelector('input[name="' + participantPhoneFieldName + '"]');
    if (!participantPhoneInput) {
      participantPhoneInput = document.createElement('input');
      participantPhoneInput.type = 'hidden';
      participantPhoneInput.name = participantPhoneFieldName;
      form.appendChild(participantPhoneInput);
    }
    participantPhoneInput.value = state.participantPhone;
  }
}


function buildParticipantPrompt() {
  var panel = document.createElement('div');
  panel.className = 'waiver-gate-participant';
  panel.setAttribute('data-waiver-participant-panel', '');

  var card = document.createElement('div');
  card.className = 'waiver-gate-participant-card';

  var title = document.createElement('h3');
  title.className = 'waiver-gate-participant-title';
  title.textContent = settings.participantPromptTitle || 'Who is this waiver for?';

  var body = document.createElement('p');
  body.className = 'waiver-gate-participant-body';
  body.textContent = settings.participantPromptBody || 'Enter the participant name, email, and phone number before opening the waiver.';

  var nameLabel = document.createElement('div');
  nameLabel.className = 'waiver-gate-participant-field-label';
  nameLabel.textContent = 'Participant name';

  var input = document.createElement('input');
  input.type = 'text';
  input.className = 'waiver-gate-participant-input';
  input.setAttribute('data-waiver-participant-input', '');
  input.setAttribute('autocomplete', 'name');
  input.setAttribute('placeholder', settings.participantPromptPlaceholder || 'Participant full name');

  var emailLabel = document.createElement('div');
  emailLabel.className = 'waiver-gate-participant-field-label';
  emailLabel.textContent = 'Participant email';

  var emailInput = document.createElement('input');
  emailInput.type = 'email';
  emailInput.className = 'waiver-gate-participant-input';
  emailInput.setAttribute('data-waiver-participant-email', '');
  emailInput.setAttribute('autocomplete', 'email');
  emailInput.setAttribute('inputmode', 'email');
  emailInput.setAttribute('placeholder', settings.participantPromptEmailPlaceholder || 'Participant email');

  var phoneLabel = document.createElement('div');
  phoneLabel.className = 'waiver-gate-participant-field-label';
  phoneLabel.textContent = 'Participant phone';

  var phoneInput = document.createElement('input');
  phoneInput.type = 'tel';
  phoneInput.className = 'waiver-gate-participant-input';
  phoneInput.setAttribute('data-waiver-participant-phone', '');
  phoneInput.setAttribute('autocomplete', 'tel');
  phoneInput.setAttribute('inputmode', 'tel');
  phoneInput.setAttribute('placeholder', settings.participantPromptPhonePlaceholder || '(555) 123-4567');

  var actions = document.createElement('div');
  actions.className = 'waiver-gate-confirm-actions';

  var cancelBtn = document.createElement('button');
  cancelBtn.type = 'button';
  cancelBtn.className = 'waiver-gate-participant-cancel';
  cancelBtn.setAttribute('data-waiver-participant-cancel', '');
  cancelBtn.textContent = settings.cancelLabel || 'Cancel';

  var continueBtn = document.createElement('button');
  continueBtn.type = 'button';
  continueBtn.className = 'waiver-gate-participant-continue';
  continueBtn.setAttribute('data-waiver-participant-continue', '');
  continueBtn.textContent = settings.participantPromptContinue || 'Continue to waiver';
  continueBtn.disabled = true;

  function validEmail(value) {
    var raw = String(value || '').trim();
    if (!raw) return false;
    return /\S+@\S+\.\S+/.test(raw);
  }

  function formatPhone(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.length > 10 && digits.charAt(0) === '1') {
      digits = digits.slice(1);
    }
    digits = digits.slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  function validPhone(value) {
    var digits = String(value || '').replace(/\D/g, '');
    return digits.length >= 10;
  }

  function updateContinueState() {
    var hasName = !!input.value.trim();
    var hasEmail = validEmail(emailInput.value);
    var hasPhone = validPhone(phoneInput.value);
    continueBtn.disabled = !(hasName && hasEmail && hasPhone);
  }

  var updateEvents = ['input', 'change', 'keyup', 'blur'];
  updateEvents.forEach(function(evt) {
    input.addEventListener(evt, updateContinueState);
    emailInput.addEventListener(evt, updateContinueState);
    phoneInput.addEventListener(evt, function() {
      phoneInput.value = formatPhone(phoneInput.value);
      updateContinueState();
    });
  });
  input.addEventListener('paste', function() {
    setTimeout(updateContinueState, 0);
  });
  emailInput.addEventListener('paste', function() {
    setTimeout(updateContinueState, 0);
  });
  phoneInput.addEventListener('paste', function() {
    setTimeout(updateContinueState, 0);
  });

  cancelBtn.addEventListener('click', function() {
    state.participantName = '';
    state.participantEmail = '';
    state.participantPhone = '';
    state.participantPromptOpen = false;
    clearStoredParticipant(state.variantId);
    setParticipantPromptOpen(false);
    closeModal();
  });

  continueBtn.addEventListener('click', function() {
    var name = input.value.trim();
    var email = emailInput.value.trim();
    var phone = phoneInput.value.trim();
    if (!name || !validEmail(email) || !validPhone(phone)) return;
    function proceed() {
      state.participantName = name;
      state.participantEmail = email;
      state.participantPhone = phone;
      saveStoredParticipant(state.variantId, {
        name: state.participantName,
        email: state.participantEmail,
        phone: state.participantPhone
      });
      state.participantPromptOpen = false;
      setParticipantPromptOpen(false);
      refreshModalTargets();
      updateDebugPanel();
    }

    function hasDuplicateContact() {
      var normalizedEmail = normalizeEmail(email);
      var normalizedPhone = normalizePhone(phone);
      var emailMatch = normalizedEmail && state.cartParticipantEmails.indexOf(normalizedEmail) !== -1;
      var phoneMatch = normalizedPhone && state.cartParticipantPhones.indexOf(normalizedPhone) !== -1;
      return emailMatch || phoneMatch;
    }

    function maybeConfirm() {
      if (hasDuplicateContact()) {
        var okDuplicate = window.confirm('This email or phone already has a waiver in your cart. Sign another waiver?');
        if (!okDuplicate) return;
      }
      if (state.cartQuantity > 0) {
        var ok = window.confirm('A registration is already in your cart. Sign another waiver?');
        if (!ok) return;
      }
      proceed();
    }

    if (state.variantId) {
      syncSessionFromCart(state.variantId).then(maybeConfirm).catch(maybeConfirm);
      return;
    }

    maybeConfirm();
  });

  actions.appendChild(cancelBtn);
  actions.appendChild(continueBtn);

  updateContinueState();
  setTimeout(updateContinueState, 50);

  card.appendChild(title);
  card.appendChild(body);
  card.appendChild(nameLabel);
  card.appendChild(input);
  card.appendChild(emailLabel);
  card.appendChild(emailInput);
  card.appendChild(phoneLabel);
  card.appendChild(phoneInput);
  card.appendChild(actions);
  panel.appendChild(card);

  return panel;
}

function setParticipantPromptOpen(enabled) {
  var modal = ensureModal();
  if (!settings.allowMultipleSessions) {
    modal.removeAttribute('data-participant-open');
    state.participantPromptOpen = false;
    return;
  }
  state.participantPromptOpen = !!enabled;
  if (state.participantPromptOpen) {
    modal.setAttribute('data-participant-open', 'true');
  } else {
    modal.removeAttribute('data-participant-open');
  }
}

function buildTaggedUrl(url, variantId) {
  if (!url) return '';
  var parsed;
  try {
    parsed = new URL(url);
  } catch (err) {
    return url;
  }

  // Keep auto_tag <= 64 chars while still encoding session/variant/product.
  var parts = [];
  if (state.sessionId) parts.push('s' + String(state.sessionId).slice(0, 32));
  if (variantId) parts.push('v' + variantId);
  if (productId) parts.push('p' + productId);
  if (!state.sessionId && cartToken) parts.push('c' + String(cartToken).slice(0, 16));
  if (!parts.length) return parsed.toString();

  var tag = parts.join('-');
  if (tag.length > 64) {
    tag = tag.slice(0, 64);
  }

  var existing = parsed.searchParams.get('auto_tag');
  var combined = existing ? (existing + '|' + tag) : tag;
  if (combined.length > 64) {
    combined = combined.slice(0, 64);
  }
  parsed.searchParams.set('auto_tag', combined);
  parsed.searchParams.set('auto_tag_source', 'shopify');
  // Prevent Smartwaiver from retaining the tag for the next signer on shared devices.
  parsed.searchParams.set('auto_anyoneelseneedtosign', '0');
  return parsed.toString();
}

function findBuyNowButton(target) {
  if (!target || !container || !target.closest) return null;
  var button = target.closest('button[name="checkout"], button[data-testid="Checkout-button"], .shopify-payment-button__button');
  if (button && container.contains(button)) {
    return button;
  }
  return null;
}

function findAddToCartButton(target) {
  if (!target || !container || !target.closest) return null;
  var button = target.closest('button[name="add"], button[type="submit"], input[type="submit"]');
  if (!button) return null;
  var form = button.form || (button.closest ? button.closest('form[action^="/cart/add"]') : null);
  if (form && container.contains(form)) {
    return { button: button, form: form };
  }
  return null;
}

function showRootWarning(message) {
  var warning = root.querySelector('[data-waiver-warning]');
  if (!warning) return;
  warning.style.display = 'block';
  warning.textContent = message;
}

function interceptEvent(event) {
  var info = getActiveInfo();
  state.variantId = info.variantId;
  state.activeUrl = info.activeUrl;
  state.taggedUrl = info.taggedUrl;

  if (!state.activeUrl) return;
  if (!container || !container.contains(event.target)) return;
  if (settings.allowMultipleSessions) {
    state.sessionId = '';
    state.sessionRequest = null;
    state.statusRequest = null;
    state.statusChecked = false;
    state.statusSigned = false;
    state.participantName = '';
    state.participantEmail = '';
    state.participantPhone = '';
    state.participantPromptOpen = false;
    state.reusedStoredSession = false;
    if (state.variantId) {
      clearStoredSession(state.variantId);
    }
  }
  requestSessionId();

  if (state.bypass) {
    state.bypass = false;
    return;
  }

  var action = null;
  var form = getForm();
  var buyButton = null;
  var addResult = null;

  if (event.type === 'submit') {
    var submitter = event.submitter || document.activeElement;
    if (isBuyNowButton(submitter)) {
      action = 'buy';
      buyButton = submitter;
    } else if (event.target && event.target.matches && event.target.matches('form[action^="/cart/add"]') && container.contains(event.target)) {
      action = 'add';
      form = event.target;
    }
  } else if (event.type === 'click') {
    buyButton = findBuyNowButton(event.target);
    if (buyButton) {
      action = 'buy';
    } else {
      addResult = findAddToCartButton(event.target);
      if (addResult) {
        action = 'add';
        form = addResult.form;
      }
    }
  }

  if (!action) return;

  event.preventDefault();
  event.stopPropagation();
  if (event.stopImmediatePropagation) {
    event.stopImmediatePropagation();
  }

  syncSessionFromCart(state.variantId).then(function() {
    if (!settings.allowMultipleSessions && state.cartQuantity > 0) {
      log('cart-limit', {
        action: action,
        variantId: state.variantId,
        cartQuantity: state.cartQuantity
      });
      showRootWarning(settings.cartLimitMessage || 'This item is already in your cart. Only one is allowed.');
      state.pendingForm = null;
      state.pendingButton = null;
      state.pendingAction = null;
      return;
    }

    state.pendingForm = action === 'add' ? form : null;
    state.pendingButton = action === 'buy' ? buyButton : null;
    state.pendingAction = action;

    log('intercept', {
      action: action,
      variantId: info.variantId,
      activeWaiverUrl: info.activeUrl
    });

    openModal();
  });
}

updateUI();

if (root.dataset && root.dataset.waiverListener !== 'true') {
  root.dataset.waiverListener = 'true';
  window.addEventListener('message', function(event) {
    if (!event || !event.data || event.data.type !== 'waiver:complete') return;
    if (!isAllowedOrigin(event.origin)) return;
    var incomingSession = event.data.sessionId || '';
    if (incomingSession && state.sessionId && incomingSession !== state.sessionId) return;
    if (!incomingSession && !state.sessionId) return;
    if (!state.sessionId && incomingSession) {
      state.sessionId = incomingSession;
    }
    state.statusSigned = !!event.data.signed;
    state.statusChecked = true;
    state.statusCheckedAt = Date.now();
    updateDebugPanel();
    if (state.statusSigned) {
      var modal = document.getElementById(modalId);
      if (modal && modal.getAttribute('data-open') === 'true') {
        var continueBtn = modal.querySelector('[data-waiver-continue]');
        if (continueBtn) {
          continueBtn.click();
        }
      }
    }
  });
}

if (container) {
  container.addEventListener('change', scheduleUpdateUI, true);
  container.addEventListener('input', scheduleUpdateUI, true);
}

document.addEventListener('click', interceptEvent, true);
document.addEventListener('submit', interceptEvent, true);
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-waiver-config]');
    for (var i = 0; i < nodes.length; i++) {
      initWaiverGate(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();